import * as React from 'react'

export const PrismicPreviewContext = React.createContext(false)

export const withPrismicPreviewPage = (Component) => {
  const WithPrismicPreviewPage = (props) => (
    <PrismicPreviewContext.Provider value={Boolean(props.isPrismicPreview)}>
      <Component {...props} />
    </PrismicPreviewContext.Provider>
  )

  WithPrismicPreviewPage.displayName = `withPrismicPreviewPage(${
    Component.displayName || Component.name || 'Component'
  })`

  return WithPrismicPreviewPage
}
